import InstallCLI from "./InstallCLI"

export default InstallCLI
